import React,{useEffect,useState} from 'react';
import Button from 'react-bootstrap/Button';
import * as Yup from 'yup';
import {InputText,Form,SelectField} from '../../components/FormElement'

import { fetchWrapper } from '../helpers';
import { useToast } from '@chakra-ui/react'



function Create({loadList,user_type_id,handleClose}){
	

const toast = useToast()

	const backendUrl = process.env.REACT_APP_API_URL

	const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    username: '',
    password:'',
    user_type_id:user_type_id,
    
  });

  const FormSchema = Yup.object().shape({
	     first_name: Yup.string()
	          .required('Required'),
	    last_name: Yup.string()
	          .required('Required'),
	    username: Yup.string()
	          .required('Required'),
	   
	    password: Yup.string()
	          .required('Required')
	     
	});


	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		   let  data = values
		  
	       
	     const url = `${backendUrl}/user/create`;
  		 await fetchWrapper.post(url,data)
  		 loadList();

  		 toast({
  		 	  position: 'top',
  		 	  variant:'top-accent',
          title: 'Congratulation.',
          description: "Record has been saved.",
          status: 'info',
          duration: 1000,
          isClosable: true,
        })
  		 handleClose();
	}

	


	return (

			<>
			<div className="create_user_form">
				<Form
			            enableReinitialize
			            validationSchema={FormSchema}
			            initialValues={formData}
			            onSubmit={onSubmit}
			 	>


			 	<InputText name="first_name" title="First Name"  />
			 	<InputText name="last_name" title="Last Name"  />
			 	<InputText name="username" title="Email"  />

			 	<InputText name="password" inputProps={{ type: "password" }} title="Password"  />
			 	


		         <Button
				            mt={4}
				            colorScheme='teal'
				            className="primary"
				            type='submit'
		          		>
		           		 Save
		          		</Button>

			</Form>
			</div>
			</>

	)
}

export default Create;